/* Inkfold scroll-reveal
   Auto-applies .vs-reveal to certain section selectors, then uses
   IntersectionObserver to add .is-revealed when each enters viewport.
*/
(function () {
  // Auto-tag common Inkfold section wrappers as revealable
  const REVEAL_SELECTORS = [
    ".vs-hero",
    ".vs-hero-product",
    ".vs-pillars",
    ".vs-featured",
    ".vs-coming-soon",
    ".vs-testimonials",
    ".vs-trust",
    ".vs-bloglist",
    ".vs-newsband",
  ];

  // Stagger child elements within these grids
  const STAGGER_SELECTORS = [
    ".vs-pillars__inner",
    ".vs-featured__grid",
    ".vs-trust__inner",
    ".vs-bloglist__grid",
    ".vs-coming-soon__grid",
    ".vs-testimonials__grid",
  ];

  REVEAL_SELECTORS.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => el.classList.add("vs-reveal"));
  });

  STAGGER_SELECTORS.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => el.classList.add("vs-reveal-stagger"));
  });

  // If IntersectionObserver isn't available, just reveal everything immediately
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(".vs-reveal, .vs-reveal-stagger").forEach((el) => {
      el.classList.add("is-revealed");
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.05,
    }
  );

  document.querySelectorAll(".vs-reveal, .vs-reveal-stagger").forEach((el) => {
    observer.observe(el);
  });

  // Safety net: if anything is still hidden after 2 seconds, reveal it
  setTimeout(() => {
    document.querySelectorAll(".vs-reveal:not(.is-revealed), .vs-reveal-stagger:not(.is-revealed)").forEach((el) => {
      el.classList.add("is-revealed");
    });
  }, 2000);
})();
